var IpcDataModel = require("./index.js");
var MetaProperties = require("cio-config").MetaProperties;
var PthComponentAttribute = require('./pth/pthComponentAttribute.js');

//move decimal point to number of places to right and return the value ignoring remaining numbers after it
function moveDecimalPoint(num, places) {
    if(isNaN(num)) return;
    places = places || 2; //default 2 decimal places

    if(num - Math.floor(num) !== 0) {//number has fractional part
        //In JavaScript due to how floating point is encoded internally there is some accurracy problem in representing the floating point number.
        //E.g., 16.15 * 100 = 1614.9999999999998
        //since this function must return the value after moving decimal places to n places right of decimal point ignoring remaining numbers (without roundoff precision)
        //a small number (0.01) is added before truncating the value. So for example 1614.9999999999998 would become 1615.0099999999998 and after truncate it becomes 1615 which is expected.
        return Math.trunc(num * Math.pow(10, places) + 0.01);
    }

    //integer
    return num * Math.pow(10, places);
};

function truncateAndAppendLeadingZero(num) {
    //0.8 -> 08, 0.08 -> 00
    return '0' + parseInt(num * 10);
};

var IpcNameHelper = {};

IpcNameHelper.getStandardPackageName = function(data) {
    var packageName = '';

    if(!data) return packageName;

    if(data.constructor === IpcDataModel.SoicSopData) {
        //package name depends on pin pitch, SOIC comes with 1.27mm pitch
        packageName = ((data.verticalPinPitch() != 1270) ? 'SOP' : 'SOIC');
    } else if(data.constructor === IpcDataModel.Sot23Data) {
        packageName = 'SOT23';
    } else if(data.constructor === IpcDataModel.SotflData) {
        packageName = 'SOTFL';
    } else if(data.constructor === IpcDataModel.CfpData) {
        packageName = 'CFP';
    } else if(data.constructor === IpcDataModel.SodData) {
        packageName = 'SOD';
    } else if(data.constructor === IpcDataModel.SodflData) {
        packageName = 'SODFL';
    } else if(data.constructor === IpcDataModel.OscillatorJLeadData) {
        packageName = 'Oscillator-J Lead';
    } else if(data.constructor === IpcDataModel.OscillatorLBendData) {
        packageName = 'Oscillator-L Bend';
    } else if(data.constructor === IpcDataModel.QfpData) {
        packageName = 'QFP';
    } else if(data.constructor === IpcDataModel.CqfpData) {
        packageName = 'CQFP';
    } else if(data.constructor === IpcDataModel.Sot223Data) {
        packageName = 'SOT223';
    } else if(data.constructor === IpcDataModel.Sot143Data) {
        packageName = 'SOT143';
    } else if(data.constructor === IpcDataModel.ToDpakData) {
        packageName = 'TO, DPAK';
    } else if(data.constructor === IpcDataModel.QfnData) {
        packageName = 'QFN';
    } else if(data.constructor === IpcDataModel.Dfn2Data) {
        packageName = 'DFN2';
    } else if(data.constructor === IpcDataModel.Dfn3Data) {
        packageName = 'DFN3';
    } else if(data.constructor === IpcDataModel.Dfn4Data) {
        packageName = 'DFN4';
    } else if(data.constructor === IpcDataModel.AluminumElectrolyticData) {
        packageName = 'ECAP (Aluminum Electrolytic Capacitor)';
    } else if(data.constructor === IpcDataModel.CrystalData) {
        packageName = 'Crystal';
    } else if(data.constructor === IpcDataModel.OscillatorCornerConcaveData) {
        packageName = 'Oscillator Corner Concave';
    } else if(data.constructor === IpcDataModel.SojData) {
        packageName = 'SOJ';
    } else if(data.constructor === IpcDataModel.BgaData) {
        packageName = 'BGA';
    } else if(data.constructor === IpcDataModel.PlccData) {
        packageName = 'PLCC';
    } else if(data.constructor === IpcDataModel.ChipData) {
        packageName = 'Chip'; 
    } else if(data.constructor === IpcDataModel.ChipLedData) {
        packageName = 'Chip LED';
    } else if(data.constructor === IpcDataModel.MelfData) {
        packageName = 'MELF';
    } else if(data.constructor === IpcDataModel.ChipArrayTwoSideConvexData) {
        packageName = 'Chiparray 2-Side Convex';
    } else if(data.constructor === IpcDataModel.ChipArrayTwoSideFlatConcaveData) {
        packageName = 'Chiparray 2-Side Flat';
    } else if(data.constructor === IpcDataModel.ChipArrayFourSideFlatConcaveData) {
        packageName = 'Chiparray 4-Side Flat';
    } else if(data.constructor === IpcDataModel.MoldedBodyData) {
        packageName = 'Molded Body';
    } else if(data.constructor === IpcDataModel.AxialData) {
        packageName = 'Axial';
    } else if(data.constructor === IpcDataModel.DipData) {
        packageName = 'DIP';
    } else if(data.constructor === IpcDataModel.HeaderStraightData) {
        packageName = 'Pin Header (Male) Straight';
    } else if(data.constructor === IpcDataModel.HeaderRightAngleData) {
        packageName = 'Pin Header (Male) Right Angle';
    } else if(data.constructor === IpcDataModel.HeaderStraightSocketData) {
        packageName = 'Receptacle Header (Female) Straight';
    } else if(data.constructor === IpcDataModel.HeaderRightAngleSocketData) {
        packageName = 'Receptacle Header (Female) Right Angle';
    } else if(data.constructor === IpcDataModel.SonData) {
        packageName = 'SON';
    } else if(data.constructor === IpcDataModel.RadialRoundData) {
        packageName = 'Radial';
    } else if(data.constructor === IpcDataModel.RadialLedRoundData) {
        packageName = 'Radial LED (Round)';
    } else if(data.constructor === IpcDataModel.CrystalHC49Data) {
        packageName = 'Crystal (HC49)';
    } else if(data.constructor === IpcDataModel.SnapLockData) {
        packageName = 'Snap Lock (lock-in)';
    } else if(data.constructor === IpcDataModel.MaleFemaleStandoffSpacerData 
        || data.constructor === IpcDataModel.FemaleStandoffSpacerData){
        packageName = 'Standoff/Spacer';
    }

    return packageName;
};

IpcNameHelper.getStandardPackageFamilyNameForDescription = function(data) {
    var familyName = "";

    switch(data.constructor) {
        case IpcDataModel.MelfData:
            var family = IpcDataModel.ComponentAttribute.melfComponentFamily;

            if(data.componentFamily() === family["RESISTOR"]) {
                familyName = 'Resistor';
            } else if(data.componentFamily() === family["DIODE"]) {
                familyName = 'Diode';
            }
        break;

        case IpcDataModel.AxialData:
            var family = IpcDataModel.PthComponentAttribute.type.AXIAL.family;

            if(data.componentFamily() === family["RESISTOR"]) {
                familyName = 'Resistor';
            } else if(data.componentFamily() === family["DIODE"]) {
                familyName = 'Diode';
            } else if(data.componentFamily() === family["FUSE"]) {
                familyName = 'Fuse';
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                familyName = 'Inductor';
            } else if(data.componentFamily() === family["NONPOLARIZED_CAPACITOR"]) {
                familyName = 'Non-Polarized Capacitor';
            } else if(data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                familyName = 'Polarized Capacitor';
            }
        break;

        case IpcDataModel.RadialRoundData:
            var family = IpcDataModel.PthComponentAttribute.type.RADIALROUND.family;

            if(data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                familyName = 'Polarized Capacitor';
            } else if(data.componentFamily() === family["NONPOLARIZED_CAPACITOR"]) {
                familyName = 'Non-Polarized Capacitor';
            } else if(data.componentFamily() === family["POLARIZED_INDUCTOR"]) {
                familyName = 'Polarized Inductor';
            } else if(data.componentFamily() === family["NONPOLARIZED_INDUCTOR"]) {
                familyName = 'Non-Polarized Inductor';
            }
        break;
    }

    return familyName;
};

//used in invoking REST service to generate 3d model
IpcNameHelper.getPackageTypeFor3dModelGeneration = function(data) {
    var packageName = '';

    if(!data) return packageName;

    if(data.constructor === IpcDataModel.SoicSopData) {
        packageName = 'soic';
    } else if(data.constructor === IpcDataModel.Sot23Data) {
        packageName = 'sot23';
    } else if(data.constructor === IpcDataModel.SotflData) {
        packageName = 'sotfl';
    } else if(data.constructor === IpcDataModel.CfpData) {
        packageName = 'cfp';
    } else if(data.constructor === IpcDataModel.SodData) {
        packageName = 'sod';
    } else if(data.constructor === IpcDataModel.SodflData) {
        packageName = 'sodfl';
    } else if(data.constructor === IpcDataModel.OscillatorJLeadData) {
        packageName = 'oscillator_j';
    } else if(data.constructor === IpcDataModel.OscillatorLBendData) {
        packageName = 'oscillator_l';
    } else if(data.constructor === IpcDataModel.QfpData
        || data.constructor === IpcDataModel.CqfpData) {
        packageName = 'qfp';
    } else if(data.constructor === IpcDataModel.Sot223Data) {
        packageName = 'sot223';
    } else if(data.constructor === IpcDataModel.Sot143Data) {
        packageName = 'sot143';
    } else if(data.constructor === IpcDataModel.ToDpakData) {
        packageName = 'dpak';
    } else if(data.constructor === IpcDataModel.QfnData) {
        packageName = 'qfn';
    } else if(data.constructor === IpcDataModel.Dfn2Data) {
        packageName = 'dfn2';
    } else if(data.constructor === IpcDataModel.Dfn3Data) {
        packageName = 'dfn3';
    } else if(data.constructor === IpcDataModel.Dfn4Data) {
        packageName = 'dfn4';
    } else if(data.constructor === IpcDataModel.AluminumElectrolyticData) {
        packageName = 'ecap';
    } else if(data.constructor === IpcDataModel.CrystalData) {
        packageName = 'crystal';
    } else if(data.constructor === IpcDataModel.OscillatorCornerConcaveData) {
        packageName = 'cornerconcave';
    } else if(data.constructor === IpcDataModel.SojData) {
        packageName = 'soj';
    } else if(data.constructor === IpcDataModel.BgaData) {
        packageName = 'bga';
    } else if(data.constructor === IpcDataModel.PlccData) {
        packageName = 'plcc';
    } else if(data.constructor === IpcDataModel.ChipData) {
        packageName = 'chip';
    } else if(data.constructor === IpcDataModel.ChipLedData) {
        packageName = 'chip_led';
    } else if(data.constructor === IpcDataModel.MelfData) {
        packageName = 'melf';
    } else if(data.constructor === IpcDataModel.ChipArrayTwoSideConvexData) {
        packageName = 'chiparray2sideconvex';
    } else if(data.constructor === IpcDataModel.ChipArrayTwoSideFlatConcaveData) {
        packageName = 'chiparray2sideflat';
    } else if(data.constructor === IpcDataModel.ChipArrayFourSideFlatConcaveData) {
        packageName = 'chiparray4sideflat';
    } else if(data.constructor === IpcDataModel.MoldedBodyData) {
        packageName = 'moldedbody';
    } else if(data.constructor === IpcDataModel.AxialData) {
        if(data.componentFamily() === IpcDataModel.PthComponentAttribute.type.AXIAL.family["RESISTOR"]
        || data.componentFamily() === IpcDataModel.PthComponentAttribute.type.AXIAL.family["INDUCTOR"]) {
            packageName = 'axial_resistor';
        } else if(data.componentFamily() === IpcDataModel.PthComponentAttribute.type.AXIAL.family["POLARIZED_CAPACITOR"]) {
            packageName = 'axial_polarized_capacitor';
        } else if(data.componentFamily() === IpcDataModel.PthComponentAttribute.type.AXIAL.family["NONPOLARIZED_CAPACITOR"]
            || data.componentFamily() === IpcDataModel.PthComponentAttribute.type.AXIAL.family["DIODE"]) {
            packageName = 'axial_diode';
        } else if(data.componentFamily() === IpcDataModel.PthComponentAttribute.type.AXIAL.family["FUSE"]) {
            packageName = 'axial_fuse';
        }
    } else if(data.constructor === IpcDataModel.DipData) {
        packageName = 'dip';
    } else if(data.constructor === IpcDataModel.HeaderStraightData) {
        packageName = 'header_straight';
    } else if(data.constructor === IpcDataModel.HeaderRightAngleData) {
        packageName = 'header_right_angle';
    } else if(data.constructor === IpcDataModel.HeaderStraightSocketData) {
        packageName = 'header_straight_socket';
    } else if(data.constructor === IpcDataModel.HeaderRightAngleSocketData) {
        packageName = 'header_right_angle_socket';
    } else if(data.constructor === IpcDataModel.SonData) {
        packageName = 'son';
    } else if(data.constructor === IpcDataModel.RadialRoundData) {
        if(data.componentFamily() === IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["POLARIZED_CAPACITOR"]
        || data.componentFamily() === IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["NONPOLARIZED_CAPACITOR"]) {
            packageName = 'radial_ecap';
        } else if(data.componentFamily() === IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["POLARIZED_INDUCTOR"]
        || data.componentFamily() === IpcDataModel.PthComponentAttribute.type.RADIALROUND.family["NONPOLARIZED_INDUCTOR"]) {
            packageName = 'radial_inductor';
        }
    } else if(data.constructor === IpcDataModel.RadialLedRoundData) {
        packageName = 'radial_round_led';
    } else if(data.constructor === IpcDataModel.CrystalHC49Data) {
        packageName = 'crystal_hc49';
    } else if(data.constructor === IpcDataModel.FemaleStandoffSpacerData) {
        packageName = 'female_standoff';
    } else if(data.constructor === IpcDataModel.MaleFemaleStandoffSpacerData) {
        packageName = 'male_female_standoff';
    } else if(data.constructor === IpcDataModel.SnapLockData) {
        packageName = 'snap_lock';
    }

    return packageName;
};

IpcNameHelper.getPackageNameForIPC = function(data) {
    var packageName = '';

    if(!data) return packageName;

    if(data.constructor === IpcDataModel.SoicSopData) {
        //package name depends on pin pitch, SOIC comes with 1.27mm pitch
        packageName = ((data.verticalPinPitch() != 1270) ? 'SOP' : 'SOIC');
    } else if(data.constructor === IpcDataModel.Sot23Data
        || data.constructor === IpcDataModel.Sot223Data
        || data.constructor === IpcDataModel.Sot143Data) {
        packageName = 'SOT';
    } else if(data.constructor === IpcDataModel.SotflData) {
        packageName = 'SOTFL';
    } else if(data.constructor === IpcDataModel.CfpData) {
        packageName = 'CFP';
    } else if(data.constructor === IpcDataModel.SodData) {
        packageName = 'SOD';
    } else if(data.constructor === IpcDataModel.SodflData) {
        packageName = 'SODFL';
    } else if(data.constructor === IpcDataModel.OscillatorJLeadData) {
        packageName = 'OSCJ';
    } else if(data.constructor === IpcDataModel.OscillatorLBendData) {
        packageName = 'OSCL'
    } else if(data.constructor === IpcDataModel.QfpData) {
        packageName = 'QFP';
    } else if(data.constructor === IpcDataModel.CqfpData) {
        packageName = 'CQFP';
    } else if(data.constructor === IpcDataModel.ToDpakData) {
        packageName = 'TO';
    } else if(data.constructor === IpcDataModel.QfnData) {
        packageName = 'QFN';
    } else if(data.constructor === IpcDataModel.Dfn2Data
        || data.constructor === IpcDataModel.Dfn3Data
        || data.constructor === IpcDataModel.Dfn4Data) {
        packageName = 'DFN';
    } else if(data.constructor === IpcDataModel.AluminumElectrolyticData) {
        packageName = 'CAPAE';
    } else if(data.constructor === IpcDataModel.CrystalData) {
        packageName = 'XTAL';
    } else if(data.constructor === IpcDataModel.OscillatorCornerConcaveData) {
        packageName = 'OSCCC';
    } else if(data.constructor === IpcDataModel.SojData) {
        packageName = 'SOJ';
    } else if(data.constructor === IpcDataModel.BgaData) {
        packageName = 'BGA';
    } else if(data.constructor === IpcDataModel.PlccData) {
        packageName = 'PLCC';
    } else if(data.constructor === IpcDataModel.DipData) {
        packageName = 'DIP';
    } else if(data.constructor === IpcDataModel.HeaderStraightData) {
        packageName = 'HDRV';
    } else if(data.constructor === IpcDataModel.HeaderRightAngleData) {
        packageName = 'HDRRA';
    } else if(data.constructor === IpcDataModel.HeaderStraightSocketData) {
        packageName = 'HDRVR';
    } else if(data.constructor === IpcDataModel.HeaderRightAngleSocketData) {
        packageName = 'HDRRAR';
    } else if(data.constructor === IpcDataModel.SonData) {
        packageName = 'SON';
    } else if(data.constructor === IpcDataModel.RadialLedRoundData) {
        packageName = 'LEDRD';
    } else if(data.constructor === IpcDataModel.CrystalHC49Data) {
        packageName = 'XTALRR';
    } else if(data.constructor === IpcDataModel.FemaleStandoffSpacerData 
        || data.constructor === IpcDataModel.MaleFemaleStandoffSpacerData) {
        packageName = 'STANDOFF';  
    } else if(data.constructor === IpcDataModel.SnapLockData) {
        packageName = 'SNAPLOCK_LOCK-IN';
    } else if(data.constructor === IpcDataModel.ChipLedData) {
        packageName = 'LEDC';
    }

    return packageName;
};

IpcNameHelper.getIPCFamilyForMetaData = function(data) {
    var IPCFamiliesForFootprint = MetaProperties["footprint"]["ipcFamily"];
    var ipcFamily = '';

    if(!data) return ipcFamily;

    if(data.constructor === IpcDataModel.SoicSopData) {
        ipcFamily = IPCFamiliesForFootprint.enums.SOIC.val;
    } else if(data.constructor === IpcDataModel.Sot23Data) {
        ipcFamily = IPCFamiliesForFootprint.enums.SOT23.val;
    } else if(data.constructor === IpcDataModel.SotflData) {
        ipcFamily = IPCFamiliesForFootprint.enums.SOTFL.val;
    } else if(data.constructor === IpcDataModel.CfpData) {
        ipcFamily = IPCFamiliesForFootprint.enums.CFP.val;
    } else if(data.constructor === IpcDataModel.SodData) {
        ipcFamily = IPCFamiliesForFootprint.enums.SOD.val;
    } else if(data.constructor === IpcDataModel.SodflData) {
        ipcFamily = IPCFamiliesForFootprint.enums.SODFL.val;
    } else if(data.constructor === IpcDataModel.OscillatorJLeadData
        || data.constructor === IpcDataModel.OscillatorLBendData
        || data.constructor === IpcDataModel.OscillatorCornerConcaveData) {
        ipcFamily = IPCFamiliesForFootprint.enums.OSCIL.val;
    } else if(data.constructor === IpcDataModel.QfpData) {
        ipcFamily = IPCFamiliesForFootprint.enums.QFP.val;
    } else if(data.constructor === IpcDataModel.CqfpData) {
        ipcFamily = IPCFamiliesForFootprint.enums.CQFP.val;
    } else if(data.constructor === IpcDataModel.Sot223Data) {
        ipcFamily = IPCFamiliesForFootprint.enums.SOT223.val;
    } else if(data.constructor === IpcDataModel.Sot143Data) {
        ipcFamily = IPCFamiliesForFootprint.enums.SOT143.val;
    } else if(data.constructor === IpcDataModel.ToDpakData) {
        ipcFamily = IPCFamiliesForFootprint.enums.DPAK.val;
    } else if(data.constructor === IpcDataModel.QfnData) {
        ipcFamily = IPCFamiliesForFootprint.enums.QFN.val;
    } else if(data.constructor === IpcDataModel.Dfn2Data
        || data.constructor === IpcDataModel.Dfn3Data
        || data.constructor === IpcDataModel.Dfn4Data) {
        ipcFamily = IPCFamiliesForFootprint.enums.DFN.val;
    } else if(data.constructor === IpcDataModel.AluminumElectrolyticData) {
        ipcFamily = IPCFamiliesForFootprint.enums.ECAP.val;
    } else if(data.constructor === IpcDataModel.CrystalData
        || data.constructor === IpcDataModel.CrystalHC49Data) {
        ipcFamily = IPCFamiliesForFootprint.enums.CRYSTAL.val;
    } else if(data.constructor === IpcDataModel.SojData) {
        ipcFamily = IPCFamiliesForFootprint.enums.SOJ.val;
    } else if(data.constructor === IpcDataModel.BgaData) {
        ipcFamily = IPCFamiliesForFootprint.enums.BGA.val;
    } else if(data.constructor === IpcDataModel.PlccData) {
        ipcFamily = IPCFamiliesForFootprint.enums.PLCC.val;
    } else if(data.constructor === IpcDataModel.ChipData) {
        ipcFamily = IPCFamiliesForFootprint.enums.CHIP.val;
    } else if(data.constructor === IpcDataModel.MelfData) {
        ipcFamily = IPCFamiliesForFootprint.enums.MELF.val;
    } else if(data.constructor === IpcDataModel.ChipArrayTwoSideConvexData
        || data.constructor === IpcDataModel.ChipArrayTwoSideFlatConcaveData
        || data.constructor === IpcDataModel.ChipArrayFourSideFlatConcaveData) {
        ipcFamily = IPCFamiliesForFootprint.enums.CHIPARR.val;
    } else if(data.constructor === IpcDataModel.MoldedBodyData) {
        ipcFamily = IPCFamiliesForFootprint.enums.MOLDED.val;
    } else if(data.constructor === IpcDataModel.AxialData) {
        ipcFamily = IPCFamiliesForFootprint.enums.AXIAL.val;
    } else if(data.constructor === IpcDataModel.DipData) {
        ipcFamily = IPCFamiliesForFootprint.enums.DIP.val;
    } else if(data.constructor === IpcDataModel.HeaderStraightData
        || data.constructor === IpcDataModel.HeaderRightAngleData
        || data.constructor === IpcDataModel.HeaderStraightSocketData
        || data.constructor === IpcDataModel.HeaderRightAngleSocketData) {
        ipcFamily = IPCFamiliesForFootprint.enums.HEADER.val;
    } else if(data.constructor === IpcDataModel.SonData) {
        ipcFamily = IPCFamiliesForFootprint.enums.SON.val;
    } else if(data.constructor === IpcDataModel.RadialRoundData
        || data.constructor === IpcDataModel.RadialLedRoundData) {
        ipcFamily = IPCFamiliesForFootprint.enums.RADIAL.val;
    }
    return ipcFamily;
};

IpcNameHelper.getPackageFamilyNameForIPC = function(data) {
    var name = '';

    switch(data.constructor) {
        case IpcDataModel.ChipData:
            var family = IpcDataModel.ComponentAttribute.chipComponentFamily;

            if(data.componentFamily() === family["RESISTOR"]) {
                name = 'RESC';
            } else if(data.componentFamily() === family["CAPACITOR"]) {
                name = 'CAPC';
            } else if(data.componentFamily() === family["DIODE_NONPOLARIZED"]) {
                name = 'DIOCN';
            } else if(data.componentFamily() === family["FERRITE_BEAD"]) {
                name = 'BEADC';
            } else if(data.componentFamily() === family["FUSE"]) {
                name = 'FUSC';
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                name = 'INDC';
            } else if(data.componentFamily() === family["THERMISTOR"]) {
                name = 'THRMC';
            } else if(data.componentFamily() === family["VARISTOR"]) {
                name = 'VARC';
            } else if(data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                name = 'CAPCP';
            } else if(data.componentFamily() === family["POLARIZED_DIODE"]) {
                name = 'DIOC';
            }
        break;

        case IpcDataModel.MelfData:
            var family = IpcDataModel.ComponentAttribute.melfComponentFamily;

            if(data.componentFamily() === family["RESISTOR"]) {
                name = 'RESMELF';
            } else if(data.componentFamily() === family["DIODE"]) {
                name = 'DIOMELF';
            }
        break;

        case IpcDataModel.MoldedBodyData:
            var family = IpcDataModel.ComponentAttribute.moldedBodyComponentFamily;

            if(data.componentFamily() === family["RESISTOR"]) {
                name = 'RESM';
            } else if(data.componentFamily() === family["CAPACITOR"]) {
                name = 'CAPM';
            } else if(data.componentFamily() === family["FUSE"]) {
                name = 'FUSM';
            } else if(data.componentFamily() === family["DIODE_NONPOLARIZED"]) {
                name = 'DIOMN';
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                name = 'INDM';
            } else if(data.componentFamily() === family["PRECISION_INDUCTOR"]) {
                name = 'INDPM';
            } else if(data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                name = 'CAPMP';
            } else if(data.componentFamily() === family["POLARIZED_DIODE"]) {
                name = 'DIOM';
            } else if(data.componentFamily() === family["LED"]) {
                name = 'LEDM';
            }
        break;

        case IpcDataModel.ChipArrayTwoSideFlatConcaveData:
        case IpcDataModel.ChipArrayFourSideFlatConcaveData:
            var family = IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE;
            var flatType = (data.leadShapeType() === IpcDataModel.ComponentAttribute.chipArrayLeadShapeType["FLAT"]);

            //depends on lead shape type
            if(data.componentFamily() === family["RESISTOR"]) {
                name = (flatType ? 'RESCAF' : 'RESCAV');
            } else if(data.componentFamily() === family["DIODE"]) {
                name = (flatType ? 'DIOCAF' : 'DIOCAV');
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                name = (flatType ? 'INDCAF' : 'INDCAV');
            } else if(data.componentFamily() === family["CAPACITOR_NONPOLARIZED"]) {
                name = (flatType ? 'CAPCAF' : 'CAPCAV');
            }
        break;

        case IpcDataModel.ChipArrayTwoSideConvexData:
            var family = IpcDataModel.ComponentAttribute.chipArrayComponentFamily.TWO_SIDE_CONVEX;
            var pinSizeSame = (data.oddPadHeightMin() === data.padHeightMin() && data.oddPadHeightMax() === data.padHeightMax());

            //depends on pin size
            if(data.componentFamily() === family["RESISTOR"]) {
                name = (pinSizeSame ? 'RESCAXE' : 'RESCAXS');
            } else if(data.componentFamily() === family["CAPACITOR_NONPOLARIZED"]) {
                name = (pinSizeSame ? 'CAPCAXE' : 'CAPCAXS');
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                name = (pinSizeSame ? 'INDCAXE' : 'INDCAXS');
            }
        break;

        case IpcDataModel.Dfn2Data:
            var family = IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_2;

            if(data.componentFamily() === family["RESISTOR"]) {
                name = 'RESDFN';
            } else if(data.componentFamily() === family["CAPACITOR_NON_POLARIZED"]) {
                name = 'CAPDFN';
            } else if(data.componentFamily() === family["DIODE"]) {
                name = 'DIODFN';
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                name = 'INDDFN';
            } else if(data.componentFamily() === family["FUSE"]) {
                name = 'FUSDFN';
            } else if(data.componentFamily() === family["CRYSTAL"]) {
                name = 'XTALDFN';
            }
        break;

        case IpcDataModel.Dfn3Data:
        case IpcDataModel.Dfn4Data:
            var family = IpcDataModel.ComponentAttribute.dfnComponentFamily.DFN_34;

            if(data.componentFamily() === family["RESISTOR"]) {
                name = 'RESDFN';
            } else if(data.componentFamily() === family["CAPACITOR_NON_POLARIZED"]) {
                name = 'CAPDFN';
            } else if(data.componentFamily() === family["DIODE"]) {
                name = 'DIODFN';
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                name = 'INDDFN';
            } else if(data.componentFamily() === family["FILTER"]) {
                name = 'FILTRDFN';
            } else if(data.componentFamily() === family["IC"]) {
                name = 'DFN';
            } else if(data.componentFamily() === family["TRANSISTOR"]) {
                name = 'TRXDFN';
            }
        break;

        case IpcDataModel.AxialData:
            var family = IpcDataModel.PthComponentAttribute.type.AXIAL.family;

            if(data.componentFamily() === family["RESISTOR"]) {
                name = 'RESAD';
            } else if(data.componentFamily() === family["DIODE"]) {
                name = 'DIOAD';
            } else if(data.componentFamily() === family["FUSE"]) {
                name = 'FUSAD';
            } else if(data.componentFamily() === family["INDUCTOR"]) {
                name = 'INDAD';
            } else if(data.componentFamily() === family["NONPOLARIZED_CAPACITOR"]) {
                name = 'CAPAD';
            } else if(data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                name = 'CAPPAD';
            }
        break;

        case IpcDataModel.RadialRoundData:
            var family = IpcDataModel.PthComponentAttribute.type.RADIALROUND.family;

            if(data.componentFamily() === family["POLARIZED_CAPACITOR"]) {
                name = 'CAPPRD';
            } else if(data.componentFamily() === family["NONPOLARIZED_CAPACITOR"]) {
                name = 'CAPRD';
            } else if(data.componentFamily() === family["POLARIZED_INDUCTOR"]) {
                name = 'INDPRD';
            } else if(data.componentFamily() === family["NONPOLARIZED_INDUCTOR"]) {
                name = 'INDRD';
            }
        break;
    }

    return name;
};

IpcNameHelper.getDensityLevelForSMDData = function(data) {
    if(!data) return "";

    return ((data.densityLevel() === 0) ? 'M' : ((data.densityLevel() === 1) ? 'N' : 'L'));
};

IpcNameHelper.getProducibilityLevelForPTHData = function(data) {
    if(!data) return "";
    if(data.constructor == IpcDataModel.FemaleStandoffSpacerData || data.constructor == IpcDataModel.MaleFemaleStandoffSpacerData) return "";

    return ((data.densityLevel() === 0) ? 'A' : ((data.densityLevel() === 1) ? 'B' : 'C'));
};

IpcNameHelper.getThermalPadInfo = function(data) {
    var length = moveDecimalPoint(data.thermalPadLength() / 1000);
    var width = moveDecimalPoint(data.thermalPadWidth() / 1000);

    if(length != width) {
        if(data.constructor == IpcDataModel.QfpData || data.constructor == IpcDataModel.QfnData) { //components are rotated
            return "T" + width + "X" + length;
        } else if(data.constructor == IpcDataModel.SonData || data.constructor == IpcDataModel.SoicSopData) { //aligned with body
            return "T" + length + "X" + width;
        }
    } else {
        return "T" + length;
    }
};

IpcNameHelper.getComponentHeightForHeaderData = function(data) {
    if(!data) return "";

    if(data instanceof IpcDataModel.HeaderStraightData) {
        return data.bodyHeightMax() + data.terminalPostLength();
    } else {
        return data.bodyHeightMax();
    }
};

//TODO: add rest of the packages and verify
IpcNameHelper.getIpcName = function(data) {
    var ipcName = 'The Unnamed Footprint';
    var packageName = 'Unnamed';

    //move decimal point to number of places to right and return the value ignoring remaining numbers after it
    function moveDecimalPoint(num, places) {
        if(isNaN(num)) return;
        places = places || 2; //default 2 decimal places

        if(num - Math.floor(num) !== 0) {//number has fractional part
            //In JavaScript due to how floating point is encoded internally there is some accurracy problem in representing the floating point number.
            //E.g., 16.15 * 100 = 1614.9999999999998
            //since this function must return the value after moving decimal places to n places right of decimal point ignoring remaining numbers (without roundoff precision)
            //a small number (0.01) is added before truncating the value. So for example 1614.9999999999998 would become 1615.0099999999998 and after truncate it becomes 1615 which is expected.
            return Math.trunc(num * Math.pow(10, places) + 0.01);
        }

        //integer
        return num * Math.pow(10, places);
    };

    function truncateAndAppendLeadingZero(num) {
        //0.8 -> 08, 0.08 -> 00
        return '0' + parseInt(num * 10);
    };

    switch(data.constructor) {
        case IpcDataModel.SoicSopData:
        case IpcDataModel.SotflData:
        case IpcDataModel.CfpData:
        case IpcDataModel.Sot23Data:
        case IpcDataModel.Sot223Data:
        case IpcDataModel.Sot143Data:
        case IpcDataModel.ToDpakData:
        case IpcDataModel.SojData:
            //for DPAK package with middle lead trimmed pin count must be decremented by one
            var pinCount = (data.constructor === IpcDataModel.ToDpakData && data.hasTruncatedPin()) ? data.horizontalPadCount() - 1 : data.horizontalPadCount();

            //Name + Pitch + P + Lead Span Nominal + X + Height Max - Pin Qty
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000) + 'P'
                    + moveDecimalPoint((data.horizontalLeadToLeadSpanMax() / 1000 + data.horizontalLeadToLeadSpanMin() / 1000)  / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000) + '-'
                    + (pinCount + (data.hasThermalPad && data.hasThermalPad() ? 1 : 0))
                    + (data.hasThermalPad && data.hasThermalPad() ? this.getThermalPadInfo(data) : "");
        break;

        case IpcDataModel.QfpData:
        case IpcDataModel.CqfpData:
            //QFP + Pitch P + Lead Span L1 X Lead Span L2 Nominal X Height Max - Pin Qty + Thermal Pad
            //L1 and L2 are along X and Y directions respectively
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000) + 'P'
                    + moveDecimalPoint((data.verticalLeadToLeadSpanMax() / 1000 + data.verticalLeadToLeadSpanMin() / 1000)  / 2) + 'X'
                    + moveDecimalPoint((data.horizontalLeadToLeadSpanMax() / 1000 + data.horizontalLeadToLeadSpanMin() / 1000)  / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000) + '-'
                    + (parseInt(2 * data.horizontalPadCount()) + parseInt(2 * data.verticalPadCount()) + (data.hasThermalPad() ? 1 : 0))
                    + (data.hasThermalPad() ? this.getThermalPadInfo(data) : "");
        break;

        case IpcDataModel.PlccData:
            //PLCC + Pitch P + Lead Span L1 X Lead Span L2 Nominal X Height Max - Pin Qty
            //L1 and L2 are along X and Y directions respectively
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000) + 'P'
                    + moveDecimalPoint((data.horizontalLeadToLeadSpanMax() / 1000 + data.horizontalLeadToLeadSpanMin() / 1000)  / 2) + 'X'
                    + moveDecimalPoint((data.verticalLeadToLeadSpanMax() / 1000 + data.verticalLeadToLeadSpanMin() / 1000)  / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000) + '-'
                    + (parseInt(2 * data.horizontalPadCount()) + parseInt(2 * data.verticalPadCount()));
        break;

        case IpcDataModel.SodData:
        case IpcDataModel.SodflData:
            //name + Lead Span Nominal + Body Width Nominal X Body Height Max
            var spanNom = (data.horizontalLeadToLeadSpanMax() / 1000 + data.horizontalLeadToLeadSpanMin() / 1000)  / 2;
            spanNom = (spanNom < 1) ? truncateAndAppendLeadingZero(spanNom) : moveDecimalPoint(spanNom, 1); //see IPC doc for details

            var bodyLengthNom = (data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2;
            bodyLengthNom = (bodyLengthNom < 1) ? truncateAndAppendLeadingZero(bodyLengthNom) : moveDecimalPoint(bodyLengthNom, 1); //see IPC doc for details

            ipcName = this.getPackageNameForIPC(data)
                    + spanNom
                    + bodyLengthNom + 'X' //Note: in DM body length is considered along y direction which is considered as width for this package
                    + moveDecimalPoint(data.bodyHeightMax() / 1000);
        break;

        case IpcDataModel.OscillatorJLeadData:
        case IpcDataModel.OscillatorLBendData:
            //name + Pitch P + Body Length X Body Width X Height - Pin Qty
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000) + 'P'
                    + moveDecimalPoint((data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000)  + '-'
                    + data.horizontalPadCount();
        break;

        case IpcDataModel.ChipArrayTwoSideFlatConcaveData:
        case IpcDataModel.ChipArrayTwoSideConvexData:
        case IpcDataModel.ChipArrayFourSideFlatConcaveData:
            //family name + Pitch P + Body Length X Body Width X Height - Pin Qty
            ipcName = this.getPackageFamilyNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000) + 'P'
                    + moveDecimalPoint((data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000)  + '-'
                    + data.horizontalPadCount();
        break;

        case IpcDataModel.ChipData:
        case IpcDataModel.ChipLedData:
        case IpcDataModel.MoldedBodyData:
            var bodyWidthNom = (data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2;
            bodyWidthNom = (bodyWidthNom < 1) ? truncateAndAppendLeadingZero(bodyWidthNom) : moveDecimalPoint(bodyWidthNom, 1); //see IPC doc for details

            var bodyLengthNom = (data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2;
            bodyLengthNom = (bodyLengthNom < 1) ? truncateAndAppendLeadingZero(bodyLengthNom) : moveDecimalPoint(bodyLengthNom, 1); //see IPC doc for details

            //component family name + Body Length + Body Width X Height
            ipcName = ((data.constructor == IpcDataModel.ChipLedData) ? (this.getPackageNameForIPC(data)) : (this.getPackageFamilyNameForIPC(data))) +
                    +bodyWidthNom
                    + bodyLengthNom + 'X' //Note: in DM body length is considered along y direction which is considered as width for this package
                    + moveDecimalPoint(data.bodyHeightMax() / 1000);
        break;

        case IpcDataModel.MelfData:
            var bodyWidthNom = (data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2;
            bodyWidthNom = (bodyWidthNom < 1) ? truncateAndAppendLeadingZero(bodyWidthNom) : moveDecimalPoint(bodyWidthNom, 1); //see IPC doc for details

            var bodyLengthNom = (data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2;
            bodyLengthNom = (bodyLengthNom < 1) ? truncateAndAppendLeadingZero(bodyLengthNom) : moveDecimalPoint(bodyLengthNom, 1); //see IPC doc for details

            //component family name + Body Length + Body Diameter
            ipcName = this.getPackageFamilyNameForIPC(data)
                    + bodyWidthNom
                    + bodyLengthNom; //Diameter
        break;

        case IpcDataModel.QfnData:
            //name + Pitch P + Body Length X Body Width X Height - Pin Qty + Thermal Pad
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000) + 'P'
                    + moveDecimalPoint((data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000)  + '-'
                    + (parseInt(2 * data.horizontalPadCount()) + parseInt(2 * data.verticalPadCount()) + (data.hasThermalPad() ? 1 : 0))
                    + (data.hasThermalPad() ? this.getThermalPadInfo(data) : "");
        break;

        case IpcDataModel.SonData:
            //name + Pitch P + Body Width X Body Length X Height - Pin Qty + Thermal Pad
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000) + 'P'
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint((data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000)  + '-'
                    + (data.horizontalPadCount() + (data.hasThermalPad() ? 1 : 0))
                    + (data.hasThermalPad() ? this.getThermalPadInfo(data) : "");
        break;

        case IpcDataModel.Dfn2Data:
        case IpcDataModel.Dfn3Data:
        case IpcDataModel.Dfn4Data:
            //family name + Body Length X Body Width X Height – Pin Qty
            ipcName = this.getPackageFamilyNameForIPC(data)
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint((data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000)  + '-'
                    + data.horizontalPadCount(); //Note: in DM body length is considered along y direction which is considered as width for this package
        break;

        case IpcDataModel.AluminumElectrolyticData:
            //name + Base Body Size X Height
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X' //body dimension should be same in X and Y direction
                    + moveDecimalPoint(data.bodyHeightMax() / 1000);
        break;

        case IpcDataModel.CrystalData:
        case IpcDataModel.OscillatorCornerConcaveData:
            //name + Body Length X Body Width X Height
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint((data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000); //Note: in DM body length is considered along y direction which is considered as width for this package
        break;

        case IpcDataModel.BgaData:
            //single pitch used in both direction: name + Pin Qty + C or N + Pitch P + Ball Columns X Ball Rows_Body Length X Body Width X Height, C: collapsing ball, N: non-collapsing ball
            //dual pitch specified: name + Pin Qty + C or N + Col Pitch X Row Pitch P + Ball Columns X Ball Rows_Body Length X Body Width X Height, C: collapsing ball, N: non-collapsing ball
            //dual pitch package name falls back to single pitch package name when both pitch are equal
            ipcName = this.getPackageNameForIPC(data)
                    + (parseInt(data.horizontalPadCount()) * parseInt(data.verticalPadCount()))
                    + ((data.terminalType() === IpcDataModel.ComponentAttribute.bgaTerminalType["Collapsing_Ball"]) ? 'C':'N')
                    + ((data.verticalPinPitch() === data.horizontalPinPitch())
                        ? moveDecimalPoint(data.verticalPinPitch() / 1000)
                        : (moveDecimalPoint(data.horizontalPinPitch() / 1000) + 'X' + moveDecimalPoint(data.verticalPinPitch() / 1000))
                        ) + 'P' //Col Pitch X Row Pitch
                    + (parseInt(data.verticalPadCount()) + 'X' + parseInt(data.horizontalPadCount())) + '_' //Ball Columns X Ball Rows
                    + moveDecimalPoint((data.bodyLengthMax() / 1000 + data.bodyLengthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint((data.bodyWidthMax() / 1000 + data.bodyWidthMin() / 1000) / 2) + 'X'
                    + moveDecimalPoint(data.bodyHeightMax() / 1000);
        break;

        case IpcDataModel.AxialData:
            //family + Lead Spacing + W Lead Width + L Body Length + D Body Diameter + producibility level (A, B, C)
            //E.g., RESAD800W52L600D150B
            ipcName = this.getPackageFamilyNameForIPC(data)
                    + moveDecimalPoint(data.getPinPitch() / 1000)
                    + 'W' + moveDecimalPoint(data.terminalWidth() / 1000)
                    + 'L' + moveDecimalPoint(data.bodyWidthMin() / 2000 + data.bodyWidthMax() / 2000)
                    + 'D' + moveDecimalPoint(data.bodyLengthMin() / 2000 + data.bodyLengthMax() / 2000);
        break;

        case IpcDataModel.DipData:
            //DIP + Lead Span + W Lead Width + P Pin Pitch + L Body Length + H Component Height + Q Pin Qty + producibility level (A, B, C)
            //E.g., DIP762W52P254L1905H508Q14B
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.leadSpan() / 1000)
                    + 'W' + moveDecimalPoint(data.terminalWidth() / 1000)
                    + 'P' + ((data.horizontalPadCount() === 2) ? 0 : moveDecimalPoint(data.verticalPinPitch() / 1000))
                    + 'L' + moveDecimalPoint(data.bodyLengthMin() / 2000 + data.bodyLengthMax() / 2000)
                    + 'H' + moveDecimalPoint(data.bodyHeightMax() / 1000)
                    + 'Q' + data.horizontalPadCount();
        break;

        //Naming as per IPC 7351C Draft
        case IpcDataModel.HeaderStraightData:
        case IpcDataModel.HeaderRightAngleData:
        case IpcDataModel.HeaderStraightSocketData:
        case IpcDataModel.HeaderRightAngleSocketData:
            var pitchInfoString = '';

            //if both pad count are 1 use pin pitch as 0
            //if either one of the pad count is 1 use pin pitch for other
            if(data.verticalPadCount() == 1 && data.horizontalPadCount() == 1) {
                pitchInfoString += '0';
            } else if(data.horizontalPadCount() == 1) {
                pitchInfoString += moveDecimalPoint(data.verticalPinPitch() / 1000);
            } else if(data.verticalPadCount() == 1) {
                pitchInfoString += moveDecimalPoint(data.horizontalPinPitch() / 1000);
            } else {//for other pad count value than 1
                if(data.verticalPinPitch() == data.horizontalPinPitch()) {
                    pitchInfoString += moveDecimalPoint(data.verticalPinPitch() / 1000);
                } else {
                    pitchInfoString += moveDecimalPoint(data.verticalPinPitch() / 1000) + 'X' + moveDecimalPoint(data.horizontalPinPitch() / 1000);
                }
            }

            //HDRV + total Pins + W Lead Width + P Row Pitch (+ X Column Pitch [if different]) + _ Row s + X Pins per Row + _ BodyLength + X Body Thickness + X Component Height + producibility level (A, B, C)
            //E.g., HDRV20W64P254_2X10_2540X254X838P
            ipcName = this.getPackageNameForIPC(data)
                    + (data.horizontalPadCount() * data.verticalPadCount())
                    + 'W' + moveDecimalPoint(data.terminalWidth() / 1000)
                    + 'P' + pitchInfoString
                    + '_' + (data.verticalPadCount() + 'X' + data.horizontalPadCount())
                    + '_' + moveDecimalPoint((data.bodyLengthMax() + data.bodyLengthMin()) / 2000)
                    + 'X' + moveDecimalPoint((data.bodyWidthMax() + data.bodyWidthMin()) / 2000)
                    + 'X' + moveDecimalPoint(this.getComponentHeightForHeaderData(data) / 1000);
        break;

        case IpcDataModel.RadialRoundData:
            //CAPRD + lead spacing + W lead width + D Body Diameter + H Body Height + producibility level (A, B, C)
            //E.g.,  CAPRD508W52D300H550B
            ipcName = this.getPackageFamilyNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000)
                    + 'W' + moveDecimalPoint(data.terminalWidth() / 1000)
                    + 'D' + moveDecimalPoint((data.bodyWidthMax() + data.bodyWidthMin()) / 2000)
                    + 'H' + moveDecimalPoint(data.bodyHeightMax() / 1000);
        break;

        case IpcDataModel.RadialLedRoundData:
            //LEDRD + lead spacing + W lead width + D Body Diameter + H Body Height + producibility level (A, B, C)
            //E.g.,  CAPRD508W52D300H550B
            var leadWidth = ''
            if(data.leadShape() === PthComponentAttribute.leadShapes["Rectangle"]){
                leadWidth += moveDecimalPoint(Math.max(data.terminalThickness(), data.terminalWidth()) / 1000)
            } else {
                leadWidth += moveDecimalPoint(data.terminalWidth() / 1000)
            };
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000)
                    + 'W' + leadWidth
                    + 'D' + moveDecimalPoint((data.bodyWidthMax() + data.bodyWidthMin()) / 2000)
                    + 'H' + moveDecimalPoint(data.bodyHeightMax() / 1000);
        break;

        case IpcDataModel.CrystalHC49Data:
            //XTALRR + lead spacing + W lead width + L Body Length + T Body Width + producibility level (A, B, C)
            ipcName = this.getPackageNameForIPC(data)
                    + moveDecimalPoint(data.verticalPinPitch() / 1000)
                    + 'W' + moveDecimalPoint(data.terminalWidth() / 1000)
                    + 'L' + moveDecimalPoint((data.bodyWidthMax() + data.bodyWidthMin()) / 2000)
                    + 'T' + moveDecimalPoint((data.bodyLengthMax() + data.bodyLengthMin()) / 2000)
                    + 'H' + moveDecimalPoint(data.bodyHeightMax() / 1000);
        break;

        case IpcDataModel.FemaleStandoffSpacerData:
        case IpcDataModel.MaleFemaleStandoffSpacerData:
            //STANDOFF _ Body Shape _ Gender_Body Width(E) X Height(A) _ Thread Designation_ [MTG + NP (non-plated) + Land Size(E1) + H + Hole Size(b) + V + No. of vias]
            var threadDesignation = ''
            var mountingHole = ''

            if(data.constructor == IpcDataModel.FemaleStandoffSpacerData){
                threadDesignation = (data.hasThread() ? '_' + data.threadDesignation(): "")
            } else {
                threadDesignation = '_' + data.postThreadDesignation()   
            };
            
            if (data.withPad()){
                mountingHole += '_MTG' 
                              + (data.plated() ? 'P': 'NP') 
                              + moveDecimalPoint(data.padDiameter() / 1000)
                              + 'H' + moveDecimalPoint(data.holeDiameter() / 1000)   
                              + ((data.withVia() && data.viaCount() != 0) ? 'V' + data.viaCount(): "")             
            };

            ipcName = this.getPackageNameForIPC(data)
                    + '_' + data.bodyShape().toUpperCase()
                    + '_' + data.gender().toUpperCase()
                    + '_' + moveDecimalPoint((data.bodyWidthMax() + data.bodyWidthMin()) / 2000)
                    + 'X' + moveDecimalPoint(data.bodyHeightMax() / 1000)
                    + threadDesignation
                    + mountingHole;
        break;

        case IpcDataModel.SnapLockData:
            // SNAPLOCK _ Mounting Type _ Body Dia(E) X Height(A) _ Board-thickness(A1) _ [MTG + NP (non-plated) + H + Hole Size(b)]
            // E.g., SNAPLOCK_LOCK-IN_320X635_157_MTGNPH320
            ipcName = this.getPackageNameForIPC(data)
                    + '_' + moveDecimalPoint(data.bodyWidthMax() / 1000)
                    + 'X' + moveDecimalPoint(data.bodyHeightMax() / 1000)
                    + '_' + moveDecimalPoint(data.boardThickness() / 1000)
                    + '_MTGNP' + 'H' + moveDecimalPoint(data.holeDiameter() / 1000);
        break;

    }

    //add density/producibility level
    if(data instanceof IpcDataModel.IpcSmdPadGeneratorData) {
        ipcName += this.getDensityLevelForSMDData(data);
    } else if(!(data instanceof IpcDataModel.SnapLockData)) {
        ipcName += this.getProducibilityLevelForPTHData(data);
    }

    return ipcName;
};

module.exports = IpcNameHelper;
